export default "__VITE_ASSET__DWkJ2MaN__"